// Language file for Booking page. Th

export default {
  content: {
    title: "จอง",
    searchPlaceholder: "ค้นหาผู้สมัคร, ตำเเหน่งงาน",
    listOfBooking: "รายการที่นัดหมาย",
    noDataFound: "ไม่พบข้อมูล",
  },

  tableHead: {
    interviewDate: "วันที่จอง",
    interviewTime: "เวลาจอง",
    candidateName: "ชื่อผู้สมัคร",
    jobPosition: "ตำเเหน่ง",
    status: "สถานะ",
  },
};
